import { Value } from '@philips-emr/tws-core';
import { registerValidator } from '@philips-emr/tws-core/lib/services/model-service';
import { validate } from '@philips-emr/tws-model/lib/formatters/date/date';

const BEFORE_CURRENT_DATE = 'before_current_date';

export default registerValidator(BEFORE_CURRENT_DATE, (value: Value) => {
  if (!value) {
    return [];
  }

  const currentDate = new Date();
  const valueDate = new Date(value as string);

  const isValidDate = validate(value)[0].valid;

  const valid = valueDate <= currentDate && isValidDate;

  return [{
    message: !valid ? 'tws.validator.invalid-date' : '',
    name: BEFORE_CURRENT_DATE,
    valid,
  }];
});
